import { TTrip } from '../../domains/trips/trip';

export const enum ETripSeatchItemAvailable {
  available = 0,
  noEmptySeats = 1,
}

export type TTripSeatchItem = TTrip & {
  available: ETripSeatchItemAvailable;
};
